import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);
(() => {
	const tempNamespace = {};
	const sliders = Array.from(document.querySelectorAll('.swiper'));
	function initSlider(el) {
		let {
			shownavigation,
			showpagination,
			slidesperview,
			slidesperviewtablet,
			slidesperviewdesktop,
			spacebetween,
			isautoplay,
			autoplaydelay,
			isloop,
			transitionspeed,
			allowtouchmove,
			freemode,
			showthumbs,
			isthumbroot,
		} = el.dataset;

		const { thumbid } = el.dataset;

		shownavigation = shownavigation === 'true';
		if (shownavigation)
			shownavigation = {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			};

		showpagination = showpagination === 'true';
		if (showpagination)
			showpagination = {
				el: '.swiper-pagination',
				type: 'bullets',
				bulletActiveClass: 'is-active',
				clickable: true,
			};

		slidesperview = parseInt(slidesperview, 10);
		if (slidesperview === 0) slidesperview = 'auto';
		slidesperviewtablet = parseInt(slidesperviewtablet, 10);
		if (slidesperviewtablet === 0) slidesperviewtablet = 'auto';
		slidesperviewdesktop = parseInt(slidesperviewdesktop, 10);
		if (slidesperviewdesktop === 0) slidesperviewdesktop = 'auto';
		spacebetween = parseInt(spacebetween, 10);

		isautoplay = isautoplay === 'true';
		autoplaydelay = parseInt(autoplaydelay, 10);
		if (isautoplay) isautoplay = { delay: autoplaydelay };

		isloop = isloop === 'true';
		const loopadditional = isloop ? slidesperviewdesktop : 0;
		transitionspeed = parseInt(transitionspeed, 10);

		allowtouchmove = allowtouchmove === 'true';
		freemode = freemode === 'true';

		showthumbs = showthumbs === 'true';
		isthumbroot = isthumbroot === 'true';
		if (showthumbs && !isthumbroot) {
			showthumbs = {
				swiper: tempNamespace[thumbid],
			};
		}

		const options = {
			slidesPerView: slidesperview,
			spaceBetween: spacebetween,
			loop: isloop,
			loopAdditionalSlides: loopadditional,
			speed: transitionspeed,
			autoplay: isautoplay,
			navigation: shownavigation,
			pagination: showpagination,
			allowTouchMove: allowtouchmove,
			freeMode: freemode,
			thumbs: showthumbs,
			watchSlides: true,
			breakpoints: {
				600: {
					slidesPerView: slidesperviewtablet,
				},
				1200: {
					slidesPerView: slidesperviewdesktop,
				},
			},
		};
		if (isthumbroot) {
			tempNamespace[thumbid] = new Swiper(el, options);
		} else {
			const slider = new Swiper(el, options);
		}
	}
	sliders.filter(el => el.dataset.isthumbroot === 'true').forEach(el => initSlider(el));
	sliders.filter(el => el.dataset.isthumbroot === 'false').forEach(el => initSlider(el));
})();
